import React from "react";
import SkeletonLoader from "./Loaders/SkeletonLoader";

function SideNavSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '12px', width: '100%' }}>
      <div style={{ display: 'flex', gap: '8px' }}>
        <SkeletonLoader
          width="64px"
          height="48px"
          variant="primary"
          borderRadius="50%"
          />
          <SkeletonLoader
            width="100%"
            height="48px"
            variant="primary"
          />
      </div>
      <div>
        <SkeletonLoader
          width="100%"
          height="472px"
          variant="primary"
        />
      </div>
    </div>
  );
}

export default SideNavSkeleton;